import React from 'react';

export const LoadingIndicator: React.FC<{ message?: string }> = ({ 
    message = 'Loading...' 
}) => (
    <div className="loading-indicator">
        <p>{message}</p>
    </div>
);

export const ErrorIndicator: React.FC<{ error: string }> = ({ error }) => (
    <div className="error-indicator">
        <p>Error: {error}</p>
    </div>
);

export const EmptyState: React.FC<{ 
    icon?: string; 
    title: string; 
    message: string; 
}> = ({ 
    icon = 'ℹ️', 
    title, 
    message 
}) => (
    <div className="empty-state">
        <div className="empty-state-content">
            <div className="empty-icon">{icon}</div>
            <h3>{title}</h3>
            <p>{message}</p>
        </div>
    </div>
);

export const InitialState: React.FC<{
    icon?: string;
    title: string;
    message: string;
}> = ({ 
    icon = '🔍', 
    title, 
    message 
}) => (
    <div className="initial-state">
        <div className="initial-state-content">
            <div className="initial-icon">{icon}</div>
            <h3>{title}</h3>
            <p>{message}</p>
        </div>
    </div>
);
